import TableCompare from "./components/TableCompare";
import { useGetProductComparisonQuery } from "@/redux-store/api/marketingApi";

const CompareSection = () => {
  const { data } = useGetProductComparisonQuery({});

  return (
    <>
      {data && (
        <TableCompare
          allProducts={data.allProducts}
          productFeatures={data.productFeatures}
        />
      )}
    </>
  );
};

export default CompareSection;
